export default {
  placeholder: 'Wybierz część',
};
